import type { MailboxInfo } from "owa-client-types";
import copilotSettingsStore from "../store/store";

export function getManifestIdForAddin(titleId: string, mailboxInfo: MailboxInfo): string | undefined {
    const store = copilotSettingsStore(mailboxInfo);
    return store.extensibility.addinInfoById.get(titleId)?.manifestId;
}
